import { apiFetch } from './api';

/** Modèles d'email, avec la liste des balises reconnues par le serveur. */
export function getModelesEmail() {
  return apiFetch('/modeles-email');
}

const API = process.env.REACT_APP_API_URL || '/api';

/**
 * Dépose (ou remplace) la pièce jointe fixe d'un modèle : un PDF envoyé
 * avec chaque email de ce type. Multipart, hors apiFetch qui force le
 * Content-Type JSON.
 */
export async function deposerPieceJointeModele(type, fichier) {
  const corps = new FormData();
  corps.append('fichier', fichier);
  const res = await fetch(`${API}/modeles-email/${type}/piece-jointe`, {
    method: 'PUT',
    credentials: 'include',
    body: corps,
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(json?.message || `Dépôt impossible (${res.status})`);
    err.status = res.status;
    throw err;
  }
  return json;
}

/** Retire la pièce jointe fixe d'un modèle. */
export function supprimerPieceJointeModele(type) {
  return apiFetch(`/modeles-email/${type}/piece-jointe`, { method: 'DELETE' });
}

/** Le type n'est pas modifiable : c'est la clé qu'utilise le code d'envoi. */
export function updateModeleEmail(type, { objet, contenu, joindreDocument }) {
  return apiFetch(`/modeles-email/${type}`, {
    method: 'PUT',
    body: JSON.stringify({ objet, contenu, joindreDocument }),
  });
}
